module.exports = __webpack_public_path__ + "static/media/scenario-2.45db0805.png";